import { useNavigate, useSearchParams } from "react-router";
import ModalSimple from "../../components/modal-simple";
import Button from "../../components/button";

function BuyFailPage() {
  const [searchParams] = useSearchParams();
  const tariff = searchParams.get('t');
  const kind = searchParams.get('k');
  const navigation = useNavigate();

  const tryAgain = () => {
    // Доплата за устройства оформляется модалкой на главной, а не на select-tariff.
    if (kind === 'upgrade') {
      navigation('/');
      return;
    }
    navigation(`/select-tariff${tariff ? `?t=${tariff}` : ''}`);
  }

  return (
    <div className="buy-fail">
      <ModalSimple>
        <h1>Оплата не прошла</h1>
        <div>
          <p>В процессе оплаты пошло что-то не так<br/>Попробуйте ещё раз</p>
        </div>
        <Button label={"Попробовать ещё раз"} onClick={() => tryAgain()}/>
      </ModalSimple>
    </div>
  );
}

export default BuyFailPage;